// Pure scoring helpers extracted VERBATIM from App.js (lines ~1372-1408).
// Formulas, ternary boundaries, and reduce logic are copied exactly as-is.
// Do NOT "improve" these — they are pinned by a characterization test.

// Compute game-wide average of integer grade points (D=1, C=2, B=3, A=4)
export const scoreToGradePoints = (s) => s <= 1 ? 1 : s <= 2 ? 2 : s <= 3 ? 3 : 4;

export const scoreMmGradePoints = (mm_actual, mm_best, mm_worst) => {
  if (mm_best === mm_worst) return 4;
  const lWorst = Math.log(mm_worst);
  const lBest = Math.log(mm_best);
  const lActual = Math.log(mm_actual);
  const norm = (lWorst - lActual) / (lWorst - lBest);
  return scoreToGradePoints(4.0 * norm);
};

export const scoreVocabGradePoints = (vocab_actual, vocab_best, vocab_worst) => {
  if (vocab_best === vocab_worst) return 4;
  const lBest = Math.log(vocab_best);
  const lWorst = Math.log(vocab_worst);
  const lActual = Math.log(vocab_actual);
  const norm = (lBest - lActual) / (lBest - lWorst);
  return scoreToGradePoints(4.0 * norm);
};

export const computeGameScores = (validMoves, n) => {
  const hasVocabData = (e) => (e.vocab_actual || 0) > 0;
  const hasOldVocabData = (e) => e.word_rank > 0 && e.word_count > 0;
  const scoredMoves = validMoves.filter(e => (hasVocabData(e) || hasOldVocabData(e)) || e.reply === "G".repeat(n));
  const gameAvgScore = scoredMoves.length > 0
    ? scoredMoves.reduce((sum, e) => sum + (e.reply === "G".repeat(n) ? 4
        : hasVocabData(e) ? scoreVocabGradePoints(e.vocab_actual, e.vocab_best, e.vocab_worst)
        : scoreToGradePoints(4 * e.word_rank / e.word_count)), 0) / scoredMoves.length
    : null;
  const gameMmScore = scoredMoves.length > 0
    ? scoredMoves.reduce((sum, e) => sum + (e.reply === "G".repeat(n) ? 4 : scoreMmGradePoints(e.mm_actual || 0, e.mm_best || 0, e.mm_worst || 0)), 0) / scoredMoves.length
    : null;
  const gameMaxScore = scoredMoves.length > 0
    ? scoredMoves.reduce((sum, e) => {
        const vocabGrade = hasVocabData(e) ? scoreVocabGradePoints(e.vocab_actual, e.vocab_best, e.vocab_worst)
          : hasOldVocabData(e) ? scoreToGradePoints(4 * e.word_rank / e.word_count) : 0;
        const mmGrade = (e.mm_actual || 0) === 0 ? 0 : scoreMmGradePoints(e.mm_actual, e.mm_best, e.mm_worst);
        return sum + (e.reply === "G".repeat(n) ? 4 : Math.max(vocabGrade, mmGrade));
      }, 0) / scoredMoves.length
    : null;
  return { gameAvgScore, gameMmScore, gameMaxScore };
};
